const eUserStatus = {
  Active: 100,
  Inactive: 200,
  DeleteRequest: 400,
};

module.exports = {
  eUserStatus,
};
